export const LANDING_CALLBACK_REQUIRED_ERROR = 'Заполните поле';
